import React from 'react';

import Paper from '@material-ui/core/Paper';

import Calendar from '../comps/Calendar.js';

export default function PageCalendar() {
  return (
    <Paper>
      <Calendar/>
    </Paper>
  )
}



// WEBPACK FOOTER //
// ./src/pages/PageCalendar.js